import { render, staticRenderFns } from "./ProblemSolvingHandlerSidebar.vue?vue&type=template&id=6105e742&scoped=true&"
import script from "./ProblemSolvingHandlerSidebar.vue?vue&type=script&lang=js&"
export * from "./ProblemSolvingHandlerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProblemSolvingHandlerSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProblemSolvingHandlerSidebar.vue?vue&type=style&index=1&id=6105e742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6105e742",
  null
  
)

export default component.exports